import { getMemberListProc } from '@/appLogic/leanpath/wrappers/getMemberListProc';
import { IYearMonth } from '@/coreDomainsModule/date';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 仕入先内示ページに係る部分
 */
export class SupplierBusinessInfoService {
  /**
   * ランダムでtrue/falseを付与する
   */
  static randomTrueFalse = (): boolean => {
    return Math.random() < 0.8; // 80%の確率でtrue
  };

  /**
   * ランダムでユーザー情報配列の中身を出力する
   */
  static randomLetterIfTrue = async (): Promise<UserAccount> => {
    // TODO: ユーザー名一覧を管理するものがそもそもないので、とりあえずメールアドレス一覧を使用している
    const letters = await getMemberListProc(); // 組織内のメンバーの情報取得
    const randomIndex = Math.floor(Math.random() * letters.length);
    const targetUser = letters[randomIndex];
    return UserAccountFactory.create({ email: targetUser.email, name: '' });
  };

  /**
   * 取引情報にユーザー名を追加する
   * @param targetBusiness - 対象の取引情報
   * @param user - 担当者
   */
  static addSupplierForecastResponsibleUserName = async (targetBusiness: IBusiness, user: UserAccount) => {
    if (targetBusiness.aggregateBusinessResponsibleUsers) {
      targetBusiness.aggregateBusinessResponsibleUsers.push(user);
    } else {
      // 一旦以下のように作成する
      targetBusiness.aggregateBusinessResponsibleUsers = [UserAccountFactory.create({ email: user.email, name: user.name })];
    }
  };

  /**
   * 開始月の選択validate関数を取得
   * @param end - 終了月
   */
  static getValidateDisabledDatesOfStart = (end?: IYearMonth) => {
    return function (date: Date): boolean {
      // 終了月が未設定の場合は、制限なく選択可能
      if (!end) return false;
      const endDate = DateService.convertIDateToDate({ ...end, day: 1 });
      // 時間を無視
      endDate.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      date.setDate(1);
      // 開始月が終了月より後の場合は選択不可
      return date > endDate;
    };
  };

  /**
   * 終了月の選択validate関数を取得
   * @param start - 開始月
   */
  static getValidateDisabledDatesOfEnd = (start?: IYearMonth) => {
    return function (date: Date): boolean {
      // 開始月が未設定の場合は、制限なく選択可能
      if (!start) return false;
      const startDate = DateService.convertIDateToDate({ ...start, day: 1 });
      // 時間を無視
      startDate.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      date.setDate(1);
      // 終了月が開始月より前の場合は選択不可
      return date < startDate;
    };
  };
}
